@if (isReady) {
  <acc-toast/>
  @if (browserSupported) {
    <aside #sidebar_main
           class="sidebar sidebar-default sidebar-white sidebar-base navs-rounded-all"
           [class.sidebar-mini]="isDesktop ? sidebarMini : !sidebarOpen">
      <div class="sidebar-header d-flex align-items-center justify-content-start">
        <acc-logo/>
        <div class="sidebar-toggle" data-toggle="sidebar" data-active="true"
             (click)="toggleSidebarState()" (keydown.enter)="toggleSidebarState()" tabindex="0">
          <i class="icon">
            <fa-icon [icon]="sidebarIcon"/>
          </i>
        </div>
      </div>
      <acc-sidebar-body/>
    </aside>
    @if (!isDesktop && sidebarOpen) {
      <div class="acc-sidebar-backdrop"
           (click)="closeMobileSidebar()" (keydown.enter)="closeMobileSidebar()" tabindex="0"></div>
    }
    <main class="main-content">
      <div class="position-relative iq-banner">
        <acc-header (accToggleSidebarState)="toggleSidebarState()"></acc-header>
      </div>
      <div class="container-fluid content-inner mt-n5 acc-main-content">
        @if (connectionLost) {
          <div class="alert alert-warning d-flex align-items-start gap-2 mb-3 acc-connection-lost" role="alert">
            <acc-icon name="warn"/>
            <div>{{ 'connection.lost'|translate }}</div>
          </div>
        }
        <acc-lifecycle-banner/>
        <!-- Mitteilungen (AVV-Zustimmung u. a.) kommen vom Backend; eine Sicherung hat keine offenen -->
        @if (!isIronBackupViewer) {
          <acc-notice-banner/>
        }
        <router-outlet/>
        @if (supportEnabled) {
          <acc-support-widget/>
        }
      </div>
      <acc-footer/>
    </main>
  } @else {
    <!-- Browser NOT supported -->
    <acc-browser-check/>
  }
} @else {
  <!-- Loading Screen -->
  <div class="d-flex justify-content-center align-items-center flex-column vh-100 vw-100">
    <acc-spinner/>
    <div class="mt-3">
      {{ 'wait'|translate }}
    </div>
  </div>
}

<!-- Global components -->
<acc-media-viewer/>
<acc-media-upload/>
<acc-deactivate-dialog/>
